import { Api } from "@/api";
import { UserLoginType, PublisherType } from "@/DTO";

export const GetPublisherById = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: PublisherType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `publisher/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToPublisherType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToPublisherType = (item: any): PublisherType => {
  return {
    id: item.id,
    name: item.name,
    created_at: item?.created_at
  };
};

